import * as t from "io-ts"
import { TFlights, Flight } from "./Flight"

export const TTransaction = t.interface({
  transId: t.number,
  gcrMode: t.string,
  flights: TFlights
})
export const TTransactions = t.array(TTransaction)

export type Transaction = t.TypeOf<typeof TTransaction>
export type Transactions = t.TypeOf<typeof TTransactions>

export type TransactionRow = Flight & { id: string; transId: number }
export type TransactionRows = Array<TransactionRow>
